module.exports = __webpack_public_path__ + "static/media/YF34_5.0bd15280.jpg";